@if (isManagedByTruecommand$ | async) {
  <tn-icon name="tn-truecommand-logo-mark-color"></tn-icon>
  <span class="truecommand-text">{{ 'Managed by TrueCommand' | translate }}</span>
}
